import ShipperOrderTableGroupTitle from './styled';

export default ShipperOrderTableGroupTitle;
